import React from "react";
import { MessageCircle } from "lucide-react";

export function whatsAppLink(phone, message) {
  let d = String(phone || "").replace(/\D/g, "");
  if (!d) return null;
  // Assume BR if 10-11 digits; prepend 55 if no country code
  if (d.length === 10 || d.length === 11) d = "55" + d;
  return `https://wa.me/${d}${message ? `?text=${encodeURIComponent(message)}` : ""}`;
}

export default function WhatsAppButton({ phone, message, label = "", testid, size = "sm" }) {
  const href = whatsAppLink(phone, message);
  if (!href) return null;
  const cls = size === "xs"
    ? "inline-flex items-center gap-1 text-[11px] px-2 py-0.5 rounded-md border border-green-600/40 text-green-700 hover:bg-green-50 transition-colors"
    : "inline-flex items-center gap-1.5 text-xs px-2.5 py-1 rounded-md border border-green-600/40 text-green-700 hover:bg-green-50 transition-colors";
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" className={cls} data-testid={testid || "wa-link"} onClick={(e) => e.stopPropagation()} title="Abrir no WhatsApp">
      <MessageCircle size={size === "xs" ? 10 : 12} /> {label || "WhatsApp"}
    </a>
  );
}
